import React from 'react'
import { OrderProductStatus } from '../../entities/order-product/OrderProduct'

import Status from '../status/Status'

export interface IOwnProps {
  status: {
    code: string,
    text: string,
  }
}

export type IProps = IOwnProps

const ProductStatus:React.FC<IProps> = (props) => {
  const {
    status,
  } = props

  if(status.code !== OrderProductStatus.CANCELED) {
    return null
  }

  return (
    <Status text={status.text}/>
  )
}

export default ProductStatus
